module.exports = __webpack_public_path__ + "a87cf2554fc8059054490950460aeb31.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/caratScale/2.00ct.png
// module id = 811
// module chunks = 0